import React from "react";
import InputField from "../../input/inputField";

interface Props {
  packageName: string;
  setPackageName: (packageName: string) => unknown;
  packageRate: string;
  setPackageRate: (packageRate: string) => unknown;
}

export const LunchPackagesForm = ({
  packageName,
  setPackageName,
  packageRate,
  setPackageRate,
}: Props) => {
  return (
    <div>
      <InputField
        value={packageName}
        setValue={setPackageName}
        label="Package name"
        placeHolder="Enter package name"
      />

      <InputField
        value={packageRate}
        setValue={setPackageRate}
        label="Package rate"
        placeHolder="Enter package rate"
      />
    </div>
  );
};
